import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { ProposalStatusService } from '../../../core/services/proposal/proposal-status/proposal-status.service'
import { PaymentMethodsService } from '../../../core/services/payment/payment-methods/payment-methods.service'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { ModalLegalEntitySubClientComponent } from '../../customer/modal_subclient/modal-legal-entity-subclient/modal-legal-entity-subclient.component'
import { ModalConsultantClientComponent } from '../../person/modal-consultant-client/modal-consultant-client.component'
import { ModalEmployeeConsultantComponent } from '../../employee/modal-employee-consultant/modal-employee-consultant.component'
import { ItemProposalCreateComponent } from '../item-proposal-create/item-proposal-create.component'
import {
  cepTransform,
  convertCurrency,
  generateHexId,
} from '../../../shared/utils/utils'
import moment from 'moment'
import { IntegerInputDirective } from '../../../shared/directives/IntegerInput'
import { ItemProposalEditComponent } from '../item-proposal-edit/item-proposal-edit.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { ResponsibleService } from '../../../core/services/person/responsible/responsible.service'
import { ServiceAdditionalProposalEditComponent } from '../../service/service-additional-proposal-edit/service-additional-proposal-edit.component'
import { AddressClientEditComponent } from '../../address/address-client-edit/address-client-edit.component'
import { JsonPipe } from '@angular/common'
import { ServiceAdditionalProposalCreateComponent } from '../../service/service-additional-proposal-create/service-additional-proposal-create.component'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service'
import { AuthService } from '../../../core/services/auth/auth.service'
import { ProposalItemService } from '../../../core/services/proposal/proposal-item/proposal-item.service'
import { ItemProposalReplicateComponent } from '../item-proposal-replicate/item-proposal-replicate.component'

@Component({
  selector: 'proposal-client-replicate',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    CurrencyInputDirective,
    ItemProposalCreateComponent,
    IntegerInputDirective,
    ItemProposalEditComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NgxMaskDirective,
    ServiceAdditionalProposalEditComponent,
    AddressClientEditComponent,
    JsonPipe,
    ServiceAdditionalProposalCreateComponent,
    ItemProposalReplicateComponent,
  ],
  templateUrl: './proposal-client-replicate.component.html',
  styleUrl: './proposal-client-replicate.component.scss',
  providers: [
    ProposalClientService,
    ProposalStatusService,
    PaymentMethodsService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class ProposalClientReplicateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private proposalClientService: ProposalClientService,
    private proposalStatusService: ProposalStatusService,
    private paymentMethodsService: PaymentMethodsService,
    private proposalItemService: ProposalItemService,
    private responsibleService: ResponsibleService,
    private commissionDividerService: CommissionDividerService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ProposalClientReplicateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    // this.user = this.authService.getInfosObject()
    if (data) {
      this.item = { user: true, data: data }
    }
  }
  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  @Output() responseEdit = new EventEmitter()

  user: any = {}
  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading = false
  idClient = -1

  ListProposalStatus: any[] = []
  ListItemsProposalReplicate: any[] = []
  ListServiceAdditional: any[] = []
  listServiceAdditionalReplicate: any[] = []
  ListPaymentMethods: any[] = []
  ListResponsible: any[] = []

  ListCommission: any[] = [
    { value: 0, description: 'tg.mob', disabled: false },
    { value: 1, description: 'Cliente', disabled: true },
    { value: 2, description: 'Personalizado', disabled: false },
  ]

  commissionDividerClient: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  commissionDividerTg: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  ListItemsProposal: any[] = []

  clientSelected: any = {}
  subClientSelected: any = {}
  consultantClientSelected: any = {}
  employeeConsultantSelected: any = {}

  ngOnInit(): void {
    this.getPaymentMethod(
      this.item.data.subClienteId != (0 || null)
        ? this.item.data.subClientePessoaId
        : this.item.data.clientePessoaId,
    )
    this.createForm()
    this.getStatusProposal()
    this.getItemsProposalbyId()
    this.getItemsAditionalProposalbyId()
    this.getCommissionDivider()
  }

  getItemsAditionalProposalbyId() {
    this.proposalItemService
      .getProposalServicoAdicionalbyProposalId(this.item.data.id)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.fillModelsServiceAdicional(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
  }

  getItemsProposalbyId() {
    this.proposalItemService
      .getProposalItembyProposalId(this.item.data.id)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.fillModels(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
  }

  getStatusProposal() {
    this.proposalStatusService.listProposalStatus().subscribe({
      next: (response: ResponseRequestModel) => {
        this.ListProposalStatus = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getCommissionDivider(id = -1) {
    if (id == -1) {
      this.commissionDividerService.getCommissionDividerDefault().subscribe({
        next: (response: ResponseRequestModel) => {
          // this.commissionDividerTg = {
          //   taxa: response.data.taxa,
          //   divisor: response.data.divisor,
          //   comissao: response.data.comissao,
          // }
          this.commissionDividerTg = {
            taxa:
              response && response.data && response.data.taxa
                ? response.data.taxa
                : 0,
            divisor:
              response && response.data && response.data.divisor
                ? response.data.divisor
                : 1,
            comissao:
              response && response.data && response.data.comissao
                ? response.data.comissao
                : 0,
          }
          this.fillCommission(this.commissionDividerTg)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    } else {
      this.commissionDividerService
        .getCommissionDividerbyClientId(id)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            if (response.data) {
              this.commissionDividerClient = {
                taxa:
                  response && response.data && response.data.taxa
                    ? response.data.taxa
                    : 0,
                divisor:
                  response && response.data && response.data.divisor
                    ? response.data.divisor
                    : 1,
                comissao:
                  response && response.data && response.data.comissao
                    ? response.data.comissao
                    : 0,
              }
              this.ListCommission[1].disabled = false
              this.form.get('typeCommission')!.setValue(1)
              this.fillCommission(this.commissionDividerClient)
            } else {
              this.commissionDividerClient = {
                taxa: 0,
                divisor: 1,
                comissao: 0,
              }
              this.fillCommission(this.commissionDividerTg)
              this.form.get('typeCommission')!.setValue(0)
              this.ListCommission[1].disabled = true
            }
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
          },
          complete: () => {},
        })
    }
  }

  fillCommission(commission: any, clear = false) {
    if (clear == false) {
      this.form
        .get('commission')!
        .setValue(convertCurrency(commission.comissao))
      this.form.get('commission')!.disable()
      this.form.get('tax')!.setValue(convertCurrency(commission.taxa))
      this.form.get('tax')!.disable()
      this.form.get('divider')!.setValue(convertCurrency(commission.divisor))
      this.form.get('divider')!.disable()
    } else {
      this.form.get('commission')!.setValue(convertCurrency(0))
      this.form.get('commission')!.enable()
      this.form.get('tax')!.setValue(convertCurrency(0))
      this.form.get('tax')!.enable()
      this.form.get('divider')!.setValue(convertCurrency(0))
      this.form.get('divider')!.enable()
    }
  }

  onSelectionChangeType(event: MatSelectChange) {
    if (event.value == 0) {
      this.fillCommission(this.commissionDividerTg)
    } else if (event.value == 1) {
      this.fillCommission(this.commissionDividerClient)
    } else {
      this.fillCommission('', true)
    }
  }

  getPaymentMethod(id: number) {
    this.ListPaymentMethods = []
    this.paymentMethodsService.listPaymentMethodsByPerson(id).subscribe({
      next: (response: ResponseRequestModel) => {
        this.ListPaymentMethods = response.data
        this.form.get('paymentMethod')!.enable()
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
        this.form.get('paymentMethod')!.enable()
      },
    })
  }

  getResponsible(id: number) {
    // this.ListResponsible = []
    // this.responsibleService.listResponsibleByPerson(id).subscribe({
    //   next: (response: ResponseRequestModel) => {
    //     this.ListResponsible = response.data
    //     this.form.get('responsible')!.enable()
    //   },
    //   error: (err: ResponseRequestModel) => {
    //     console.error(err)
    //   },
    //   complete: () => {
    //     this.form.get('responsible')!.enable()
    //   },
    // })
  }

  fillForm(item: any) {
    this.clientSelected = {
      id: item.clienteId,
      nome: item.nomeCliente,
    }
    this.idClient = this.clientSelected.id
    if (item.subClienteId && item.subClienteId != 0) {
      this.subClientSelected = {
        id: item.subClienteId,
        nome: item.nomeSubCliente,
      }
      this.form.get('subClient')!.enable()
      this.idClient = this.subClientSelected.id
    }
    if (item.consultorId != 0) {
      this.consultantClientSelected = {
        id: item.consultorId,
        consultorId: item.consultorId,
        nome: item.nomeConsultor,
      }
    }
    if (item.consultorComercialId != 0) {
      this.employeeConsultantSelected = {
        id: item.consultorComercialId,
        nome: item.consultorComercial,
      }
    }
    // this.form.get('statusProposal')!.setValue(item.statusPropostaId)
    // this.form.get('statusProposal')!.setValue(item.statusPropostaDescricao)
    // this.form.get('dateEmission')!.setValue(item.dataCriacao)
    this.form.get('eventName')!.setValue(item.nomeEvento)
    this.form.get('client')!.setValue(this.clientSelected.nome)
    this.form.get('subClient')!.setValue(this.subClientSelected.nome ?? '')
    this.form
      .get('consultant')!
      .setValue(this.consultantClientSelected.nome ?? '')
    this.form
      .get('employeeConsultant')!
      .setValue(this.employeeConsultantSelected.nome ?? '')
    // this.form.get('serviceFee')!.setValue(convertCurrency(item.taxa))
    this.form.get('grandTotal')!.setValue(convertCurrency(item.valorTotal))
    this.form.get('numPassengers')!.setValue(item.quantidadePassageiros)
    this.form.get('paymentMethod')!.setValue(item.formaPagamentoId)
    this.form
      .get('dateStart')!
      .setValue(moment(item.dataInicio, 'DD/MM/YYYY').toDate())
    this.form
      .get('dateEnd')!
      .setValue(moment(item.dataFim, 'DD/MM/YYYY').toDate())

    this.form.get('requesterName')!.setValue(item.solicitante)
    this.form.get('requesterEmail')!.setValue(item.solicitanteEmail)
    this.form.get('requesterPhone')!.setValue(item.solicitanteTelefone)

    // this.form.get('tgCod')!.setValue(item.codigoTg)

    this.form.get('statusProposal')!.disable()
    this.form.get('grandTotal')!.disable()
  }

  createProposalClient() {
    this.loading = true
    const model = this.createModel()

    this.proposalClientService.createProposalClient(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  checkForm() {
    if (
      this.form.valid &&
      this.ListItemsProposal.length > 0 &&
      this.checkItemsValid() &&
      !this.loading
    ) {
      return true
    } else {
      return false
    }
  }

  checkItemsValid() {
    if (
      this.ListItemsProposal.length > 0 &&
      !this.ListItemsProposal.some((item) => item.valid == false)
    ) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      propostaCliente: {
        clienteId: this.clientSelected.id,
        subClienteId: this.subClientSelected.id ?? 0,
        consultorId: this.consultantClientSelected.consultorId ?? 0,
        nomeEvento: this.form.get('eventName')?.value ?? '',
        formaPagamentoId: this.form.get('paymentMethod')?.value ?? '',
        consultorComercialId: this.employeeConsultantSelected.id ?? 0,
        dataInicio: moment(this.form.get('dateStart')!.value).format(
          'DD/MM/YYYY',
        ),
        // horaInicio: this.form.get('timeStart')!.value,
        dataFim: moment(this.form.get('dateEnd')!.value).format('DD/MM/YYYY'),
        // horaFim: this.form.get('timeEnd')!.value,
        quantidadePassageiros:
          parseInt(this.form.get('numPassengers')?.value) ?? 0,
        solicitante: this.form.get('requesterName')?.value ?? '',
        solicitanteEmail: this.form.get('requesterEmail')?.value ?? '',
        solicitanteTelefone: this.form.get('requesterPhone')?.value ?? '',
        // tipoComissao: this.form.get('typeCommission')?.value ?? '',
        // comissao: this.form.get('commission')?.value ?? '',
        // taxa: this.form.get('tax')?.value ?? '',
        // divisor: this.form.get('divider')?.value ?? '',
      },
      itens: this.getItemsProposal(),
      servicosAdicionais: this.getItemsAdditional(),
    }
  }

  getItemsAdditional() {
    const list: any[] = []
    for (let index = 0; index < this.ListServiceAdditional.length; index++) {
      const element = this.ListServiceAdditional[index]
      list.push({
        servicoAdicionalId: element.serviceAdditionalId,
        dataServico: element.date_formatted,
        quantidade: element.amount,
        taxa: parseFloat(element.tax),
        valorUnitario: parseFloat(element.priceUnit),
        valorTotal: parseFloat(element.priceTotal),
      })
    }

    return list
  }

  getItemsProposal() {
    const items = []
    for (let index = 0; index < this.ListItemsProposal.length; index++) {
      const element = this.ListItemsProposal[index]
      const itineraries = []
      for (
        let indexItineraries = 0;
        indexItineraries < element.intinerarios.length;
        indexItineraries++
      ) {
        const elementItineraries = element.intinerarios[indexItineraries]
        itineraries.push({
          localParada: elementItineraries.descricao,
          descricao: '',
          cep: elementItineraries.cep,
          logradouro: elementItineraries.logradouro,
          numero: elementItineraries.numero,
          bairro: elementItineraries.bairro,
          latitude:
            elementItineraries.latitude != ''
              ? elementItineraries.latitude
              : null,
          longitude:
            elementItineraries.longitude != ''
              ? elementItineraries.longitude
              : null,
          cidade: elementItineraries.cidade,
          estado: elementItineraries.estado,
          complemento: elementItineraries.complemento,
          trecho: elementItineraries.trecho,
          areaTarifario: elementItineraries.areaTarifario,
        })
      }

      if (
        // element.origin.cep != '' &&
        // element.origin.logradouro != '' &&
        // element.origin.numero != '' &&
        // element.origin.bairro != '' &&
        element.origin.cidade != '' &&
        element.origin.estado != ''
      ) {
        itineraries.push({
          // localParada: 'Origem',
          localParada: element.origin.descricao,
          cep: element.origin.cep,
          logradouro: element.origin.logradouro,
          numero: element.origin.numero,
          bairro: element.origin.bairro,
          latitude:
            element.origin.latitude != '' ? element.origin.latitude : null,
          longitude:
            element.origin.longitude != '' ? element.origin.longitude : null,
          cidade: element.origin.cidade,
          estado: element.origin.estado,
          complemento: element.origin.complemento,
          trecho: 'O',
          areaTarifario: 'S',
          descricao: element.origin.cidade,
          // descricao: element.origin.descricao,
        })
      }

      if (
        // element.destination.cep != '' &&
        // element.destination.logradouro != '' &&
        // element.destination.numero != '' &&
        // element.destination.bairro != '' &&
        element.destination.cidade != '' &&
        element.destination.estado != ''
      ) {
        itineraries.push({
          // localParada: 'Destino',
          localParada: element.destination.descricao,
          cep: element.destination.cep,
          logradouro: element.destination.logradouro,
          numero: element.destination.numero,
          bairro: element.destination.bairro,
          latitude:
            element.destination.latitude != ''
              ? element.destination.latitude
              : null,
          longitude:
            element.destination.longitude != ''
              ? element.destination.longitude
              : null,
          cidade: element.destination.cidade,
          estado: element.destination.estado,
          complemento: element.destination.complemento,
          trecho: 'D',
          areaTarifario: 'S',
          descricao: element.destination.cidade,
          // descricao: element.destination.descricao,
        })
      }

      items.push({
        tarifarioId:
          element.tarifarioId && element.tarifarioId != ''
            ? element.tarifarioId
            : null,
        origemId: element.origemId,
        destinoId: element.destinoId,
        tipoServicoId: element.tipoServicoId,
        servicoId: element.servicoId,
        tipoVeiculoId: element.tipoVeiculoId,
        tipoMotoristaId: element.tipoMotoristaId,

        tipoTarifarioId: element.tipoTarifarioId,

        quantidadePassageiros: element.numPessoas,
        quantidadeVeiculos: element.numVeiculos,

        valorUnitario:
          typeof element.vendaUnitario != 'number'
            ? convertCurrency(element.vendaUnitario)
            : element.vendaUnitario,
        valorVenda:
          typeof element.vendaSemTaxa != 'number'
            ? convertCurrency(element.vendaSemTaxa)
            : element.vendaSemTaxa,
        valorComTaxa:
          typeof element.venda != 'number'
            ? convertCurrency(element.venda)
            : element.venda,
        valorTaxa:
          typeof element.valorTaxa != 'number'
            ? convertCurrency(element.valorTaxa)
            : element.valorTaxa,
        valorKmVenda:
          typeof element.saleKmExtra != 'number'
            ? convertCurrency(element.saleKmExtra)
            : element.saleKmExtra,
        valorHoraVenda:
          typeof element.saleHoraExtra != 'number'
            ? convertCurrency(element.saleHoraExtra)
            : element.saleHoraExtra,

        isPermuta: element.isPermuta ? 'S' : 'N',
        isComissiona: element.isCortesia ? 'S' : 'N',
        isCortesia: element.isCortesia ? 'S' : 'N',

        dataInicio: element.dataInicioFormatada,
        horaInicio: element.horaInicio == '' ? '' : element.horaInicio + ':00',

        dataFinal: element.dataFinalFormatada,
        horaFinal: element.horaFinal == '' ? '' : element.horaFinal + ':00',

        tipoDivisor: element.tipoComissao,
        taxa:
          typeof element.taxa != 'number'
            ? convertCurrency(element.taxa)
            : element.taxa,
        divisor:
          typeof element.divisor != 'number'
            ? convertCurrency(element.divisor)
            : element.divisor,
        comissao:
          typeof element.comissao != 'number'
            ? convertCurrency(element.comissao)
            : element.comissao,

        itinerarios: itineraries,
        observacao: element.observacao,
      })
    }

    return items
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      statusProposal: [2],
      eventName: ['', [Validators.required]],
      dateStart: ['', [Validators.required]],
      // timeStart: ['', [Validators.required]],
      dateEnd: ['', [Validators.required]],
      // timeEnd: ['', [Validators.required]],
      client: ['', [Validators.required]],
      subClient: [''],
      consultant: ['', [Validators.required]],
      employeeConsultant: [''],
      serviceFee: [convertCurrency(0)],
      // serviceFee: [convertCurrency(0), [Validators.required]],
      grandTotal: [convertCurrency(0), [Validators.required]],
      numPassengers: ['', [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      requesterName: ['', [Validators.required]],
      requesterEmail: ['', [Validators.required]],
      requesterPhone: ['', [Validators.required]],
      typeCommission: [0],
      // commission: ['', [Validators.required]],
      // divider: ['', [Validators.required]],
      // tax: ['', [Validators.required]],
      commission: [''],
      divider: [''],
      tax: [''],
      // responsible: [''],
    })
    this.form.get('statusProposal')!.disable()
    // this.form.get('subClient')!.disable()
    // this.form.get('consultant')!.disable()
    this.form.get('grandTotal')!.disable()
    this.form.get('paymentMethod')!.disable()
    // this.form.get('responsible')!.disable()

    if (this.user.funcionarioFuncaoId && this.user.funcionarioFuncaoId == 4) {
      this.employeeConsultantSelected = {
        id: this.user.funcionarioId,
        nome: this.user.name,
      }
      this.form.get('employeeConsultant')!.setValue(this.user.name)
    }

    this.fillForm(this.item.data)
  }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
        create: true,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.clientSelected.id) {
            this.clientSelected = response.selection
            this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
            this.clearItem([
              'subClient',
              'consultant',
              'paymentMethod',
              'responsable',
            ])
            this.form.get('subClient')!.enable()
            this.form.get('consultant')!.enable()
            this.getPaymentMethod(this.clientSelected.pessoaId)
            this.getResponsible(this.clientSelected.pessoaId)
            this.idClient = this.clientSelected.id
            this.getCommissionDivider(this.clientSelected.id)
          }
        } else {
          this.clearItem([
            'client',
            'subClient',
            'consultant',
            'paymentMethod',
            'responsable',
          ])
          this.form.get('subClient')!.disable()
          this.form.get('consultant')!.disable()
          this.form.get('paymentMethod')!.disable()
          // this.form.get('responsible')!.disable()
          this.idClient = -1
          this.commissionDividerClient = {
            taxa: 0,
            divisor: 0,
            comissao: 0,
          }
          this.fillCommission(this.commissionDividerTg)
          this.form.get('typeCommission')!.setValue(0)
          this.ListCommission[1].disabled = true
        }
      }
    })
  }

  addSubClient() {
    const dialogRef = this.dialog.open(ModalLegalEntitySubClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        idClient: this.clientSelected.id,
        clientInfo: this.clientSelected,
        item: this.subClientSelected,
        multiSelect: false,
        create: true,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.subClientSelected.id) {
            this.subClientSelected = response.selection
            this.form
              .get('subClient')!
              .setValue(this.subClientSelected.nomeFantasia)
            this.clearItem(['consultant', 'paymentMethod', 'responsible'])
            this.getPaymentMethod(this.subClientSelected.pessoaId)
            this.getResponsible(this.subClientSelected.pessoaId)
            this.idClient = this.subClientSelected.id
            this.getCommissionDivider(this.subClientSelected.id)
          }
        } else {
          this.clearItem([
            'subClient',
            'consultant',
            'paymentMethod',
            'responsible',
          ])
          this.getPaymentMethod(this.clientSelected.id)
          this.getResponsible(this.clientSelected.id)
          this.idClient = this.clientSelected.id
          this.getCommissionDivider(this.clientSelected.id)
        }
      }
    })
  }

  addConsultantClient() {
    const idClient =
      this.subClientSelected && this.subClientSelected.id
        ? this.subClientSelected.id
        : this.clientSelected.id
    const dialogRef = this.dialog.open(ModalConsultantClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        idClient: idClient,
        item: {
          id: this.consultantClientSelected.consultorId,
          description: this.consultantClientSelected,
        },
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (
            response.selection.consultorId !=
            this.consultantClientSelected.consultorId
          ) {
            this.consultantClientSelected = response.selection
            this.form
              .get('consultant')!
              .setValue(this.consultantClientSelected.nome)
            this.form
              .get('requesterName')!
              .setValue(this.consultantClientSelected.nome)
            this.form
              .get('requesterEmail')!
              .setValue(this.consultantClientSelected.email)
            this.form
              .get('requesterPhone')!
              .setValue(this.consultantClientSelected.telefone)
          }
        } else {
          this.clearItem(['consultant'])
        }
      }
    })
  }

  addEmployeeConsultant() {
    const dialogRef = this.dialog.open(ModalEmployeeConsultantComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.employeeConsultantSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.employeeConsultantSelected = response.selection
          this.form
            .get('employeeConsultant')!
            .setValue(this.employeeConsultantSelected.nome)
        } else {
          this.clearItem(['employeeConsultant'])
        }
      }
    })
  }

  clearItem(items: string[]) {
    if (items.includes('client')) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
    }
    if (items.includes('subClient')) {
      this.subClientSelected = {}
      this.form.get('subClient')!.setValue('')
    }
    if (items.includes('consultant')) {
      this.consultantClientSelected = {}
      this.form.get('consultant')!.setValue('')
      this.form.get('requesterName')!.setValue(``)
      this.form.get('requesterEmail')!.setValue(``)
      this.form.get('requesterPhone')!.setValue(``)
    }
    if (items.includes('employeeConsultant')) {
      this.employeeConsultantSelected = {}
      this.form.get('employeeConsultant')!.setValue('')
    }
    if (items.includes('paymentMethod')) {
      this.ListPaymentMethods = []
      this.form.get('paymentMethod')!.setValue('')
    }
    if (items.includes('responsible')) {
      // this.ListResponsible = []
      // this.form.get('responsible')!.setValue('')
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }

  getList(list: any[]) {
    this.ListItemsProposal = list
    this.updateGrandTotal()
    this.checkItensProposal()
  }

  getListServiceAdditional(list: any[]) {
    this.ListServiceAdditional = list
    this.updateGrandTotal()
  }

  checkItensProposal() {
  }

  updateGrandTotal() {
    let totalSale = 0
    for (let index = 0; index < this.ListItemsProposal.length; index++) {
      const element = this.ListItemsProposal[index]
      if (typeof element.venda == 'string') {
        // @ts-ignore
        totalSale = totalSale + convertCurrency(element.venda)
      } else if (typeof element.venda == 'number') {
        totalSale = totalSale + element.venda
      }
    }
    for (let index = 0; index < this.ListServiceAdditional.length; index++) {
      const element = this.ListServiceAdditional[index]
      if (typeof element.priceTotal == 'string') {
        // @ts-ignore
        totalSale = totalSale + convertCurrency(element.priceTotal)
      } else if (typeof element.priceTotal == 'number') {
        totalSale = totalSale + element.priceTotal
      }
    }

    // this.ListItemsProposal.reduce(
    //   (total, ele) => total + convertCurrency(ele.venda),
    //   0,
    // )

    totalSale = Math.ceil(!isFinite(totalSale) ? 0 : (totalSale ?? 0))

    this.form.get('grandTotal')!.setValue(convertCurrency(totalSale))
  }

  fillResponsible() {
    // if (this.form.get('responsible')!.value != '') {
    //   let responsible = this.form.get('responsible')!.value
    //
    //   this.form.get('requesterName')!.setValue(responsible.nome ?? '')
    //   this.form.get('requesterPhone')!.setValue(responsible.telefone ?? '')
    //   this.form.get('requesterEmail')!.setValue(responsible.email ?? '')
    //
    //   this.form.get('responsible')!.setValue('')
    // }
  }

  getPeriod() {
    return {
      dataInicio: moment(this.form.get('dateStart')!.value).format(
        'DD/MM/YYYY',
      ),
      dataFim: moment(this.form.get('dateEnd')!.value).format('DD/MM/YYYY'),
      dataInicioDescription: this.form.get('dateStart')!.value,
      dataFimDescription: this.form.get('dateEnd')!.value,
    }
  }

  fillModelsServiceAdicional(response: any) {
    this.listServiceAdditionalReplicate = []
    const list: any[] = []
    if (response.data && response.data.length > 0) {
      for (let i = 0; i < response.data.length; i++) {
        const ele = response.data[i]
        const item: any = {
          amount: ele.quantidade,
          priceUnit: convertCurrency(ele.valorUnitario),
          priceTotal: convertCurrency(ele.valorTotal),
          date: moment(ele.dataServico),
          serviceAdditionalId: ele.servicoAdicionalId,
          serviceAdditional: {
            id: ele.servicoAdicionalId,
            descricao: ele.descricao,
            valor: ele.valorOriginal,
            valorFormatado: convertCurrency(ele.valorOriginal),
          },
          descricao: ele.descricao,
          priceUnit_formatted: 'R$ ' + convertCurrency(ele.valorUnitario),
          date_formatted: ele.dataServico,
          priceTotal_formatted: 'R$ ' + convertCurrency(ele.valorTotal),
          tax: ele.taxa,
          tax_formatted: convertCurrency(ele.taxa) + ' %',
          idCreate: this.createId(list, 'idCreate'),
        }

        list.push(item)
      }
    }
    this.listServiceAdditionalReplicate = list
  }

  fillModels(response: any) {
    this.ListItemsProposalReplicate = []
    for (let index = 0; index < response.data.length; index++) {
      const element = response.data[index]
      const itinerario = this.getItineraries(element.itinerarios)
      const tarifario = this.getTarifario(element, itinerario)
      const item = {
        cidadeDestino: itinerario.destino.cidade,
        cidadeOrigem: itinerario.origem.cidade,
        comissao: element.comissao,
        custo: element.custo ? convertCurrency(element.custo) : '0,0',
        custoFormatado:
          'R$ ' + element.custo ? convertCurrency(element.custo) : '0,0',
        custoHoraExtra: element.custoHoraExtra
          ? convertCurrency(element.custoHoraExtra)
          : '0,0',
        custoHoraExtraFormatado:
          'R$ ' + element.custoHoraExtra
            ? convertCurrency(element.custoHoraExtra)
            : '0,0',
        custoKmExtra: element.custoKmExtra
          ? convertCurrency(element.custoKmExtra)
          : '0,0',
        custoKmExtraFormatado:
          'R$ ' + element.custoKmExtra
            ? convertCurrency(element.custoKmExtra)
            : '0,0',
        dataFinal: moment(element.dataFinal, 'DD/MM/YYYY').toDate(),
        dataFinalFormatada: element.dataFinal,
        dataInicio: moment(element.dataInicio, 'DD/MM/YYYY').toDate(),
        dataInicioFormatada: element.dataInicio,
        destino: element.destino,
        destinoId: element.destinoId,
        divisor: element.divisor,
        estadoDestino: itinerario.destino.estado,
        estadoOrigem: itinerario.origem.estado,
        horaFinal: element.horaFinal ? element.horaFinal : ``,
        horaInicio: element.horaInicio ? element.horaInicio : ``,
        idCreate: this.createId(this.ListItemsProposal, 'idCreate'),
        isComisionado: element.isComissiona == 'S' ? true : false,
        isCortesia: element.isCortesia == 'S' ? true : false,
        isPermuta: element.isPermuta == 'S' ? true : false,
        numPessoas: element.quantidadePassageiros,
        numVeiculos: element.quantidadeVeiculos,
        observacao: element.observacao,
        origem: element.origem,
        origemId: element.origemId,
        perimetroUrbano: element.perimetroUrbano ?? 'N',
        saleHoraExtra: element.custoHoraExtra
          ? convertCurrency(element.custoHoraExtra)
          : '0,0',
        saleHoraExtraFormatado:
          'R$ ' + element.custoHoraExtra
            ? convertCurrency(element.custoHoraExtra)
            : '0,0',
        saleKmExtra: element.custoKmExtra
          ? convertCurrency(element.custoKmExtra)
          : '0,0',
        saleKmExtraFormatado:
          'R$ ' + element.custoKmExtra
            ? convertCurrency(element.custoKmExtra)
            : '0,0',
        servico: element.descricaoServico,
        servicoId: element.servicoId,
        tarifarioId: '',
        taxa: element.taxa,
        tipoComissao: element.tipoDivisor,
        tipoMotorista: element.descricaoTipoMotorista,
        tipoMotoristaId: element.tipoMotoristaId,
        tipoServico: element.descricaoTipoServico,
        tipoServicoId: element.tipoServicoId,
        tipoTarifarioId: element.tipoTarifarioId,
        tipoVeiculo: element.descricaoTipoVeiculo,
        tipoVeiculoId: element.tipoVeiculoId,
        valorTaxa: element.valorTaxa
          ? convertCurrency(element.valorTaxa)
          : '0,0',
        valorTaxaFormatado:
          'R$ ' + element.valorTaxa
            ? convertCurrency(element.valorTaxa)
            : '0,0',
        venda: element.valorComTaxa
          ? convertCurrency(element.valorComTaxa)
          : '0,0',
        vendaFormatado:
          'R$ ' + element.valorComTaxa
            ? convertCurrency(element.valorComTaxa)
            : '0,0',
        vendaSemTaxa: element.valorVenda
          ? convertCurrency(element.valorVenda)
          : '0,0',
        vendaSemTaxaFormatado:
          'R$ ' + element.valorVenda
            ? convertCurrency(element.valorVenda)
            : '0,0',
        vendaUnitario: element.valorUnitario
          ? convertCurrency(element.valorUnitario)
          : '0,0',
        vendaUnitarioFormatado:
          'R$ ' + element.valorUnitario
            ? convertCurrency(element.valorUnitario)
            : '0,0',
        intinerarios:
          itinerario.paradas && itinerario.paradas.length > 0
            ? itinerario.paradas.reverse()
            : itinerario.paradas,
        destination: itinerario.destino,
        origin: itinerario.origem,
        tarifario: tarifario,
        valid: false,
      }
      this.ListItemsProposalReplicate.push(item)
    }
  }
  getItineraries(itineraries: any[]) {
    const newItineraries: any = {
      origem: {},
      destino: {},
      paradas: [],
    }
    for (let index = 0; index < itineraries.length; index++) {
      const element = itineraries[index]
      const model = {
        idCreate: this.createId(newItineraries.paradas, 'idCreate'),
        areaTarifario: element.areaTarifario,
        bairro: element.bairro,
        cep: cepTransform(element.cep),
        cidade: element.cidade,
        complemento: element.complemento,
        descricao: element.localParada,
        estado: element.estado,
        latitude: element.latitude,
        logradouro: element.logradouro,
        longitude: element.longitude,
        numero: element.numero,
        pais: 'Brasil',
        trecho: element.trecho,
      }
      if (element.trecho.toUpperCase() == 'O') {
        newItineraries.origem = model
      } else if (element.trecho.toUpperCase() == 'D') {
        newItineraries.destino = model
      } else {
        newItineraries.paradas.push(model)
      }
    }

    return newItineraries
  }
  createId(list: any[], key = 'id') {
    let id = generateHexId()
    if (list.length == 0) {
      return id
    } else {
      let idDistinct = false
      while (!idDistinct) {
        if (
          list.findIndex((ele: any) => {
            return ele[key] == id
          }) == -1
        ) {
          idDistinct = true
        } else {
          id = generateHexId()
        }
      }
      return id
    }
  }

  getTarifario(element: any, itinerario: any) {
    const model = {
      ativo: 'S',
      cidadeDestino: itinerario.destino.cidade,
      cidadeOrigem: itinerario.origem.cidade,
      cliente: null,
      clienteId: 0,
      custo: '',
      custoHoraExtra: '',
      custoHoraExtra_formatado: '',
      custo_formatado: '',
      custokmExtra: '',
      custokmExtra_formatado: '',
      dataCriacao: '',
      dataValidade: '',
      destination: itinerario.destino,
      destino: element.destino,
      destinoId: element.destinoId,
      estadoDestino: itinerario.destino.estado,
      estadoOrigem: itinerario.origem.estado,
      fornecedor: '',
      fornecedorId: '',
      horaCriacao: '',
      import: null,
      isComission: element.isComissiona == 'S' ? true : false,
      location: '',
      login: '',
      origem: element.origem,
      origemId: element.origemId,
      origin: itinerario.origem,
      paisDestino: 'Brasil',
      paisOrigem: 'Brasil',
      perimetroUrbano: element.perimetroUrbano ?? 'N',
      pessoaId: '',
      servico: element.descricaoServico,
      servicoId: element.servicoId,
      standard: 'N',
      subCliente: null,
      tipoId: element.tipoTarifarioId,
      tipoTarifarioId: element.tipoTarifarioId,
      tipoMotorista: element.descricaoTipoMotorista,
      tipoMotoristaId: element.tipoMotoristaId,
      tipoServico: element.descricaoTipoServico,
      tipoServicoId: element.tipoServicoId,
      tipoTarifario: '',
      tipoVeiculo: element.descricaoTipoVeiculo,
      tipoVeiculoId: element.tipoVeiculoId,
      usuario: '',
      usuarioId: null,
    }
    return model
  }
}

/*

*/

/*
{
propostaCliente: {
clienteId: 137,
consultorComercialId: 7,
consultorId: 434,
dataFim: "20/12/2025",
dataInicio: "16/12/2025",
formaPagamentoId: 184,
nomeEvento: "Evento Replicar Proposta",
quantidadePassageiros: 12,
solicitante: "Wanderson Borges",
solicitanteEmail: "wander.borges@abong.org.br",
solicitanteTelefone: "11918239848",
subClienteId: 0
},
servicosAdicionais:[
{
clienteId: 137,
consultorComercialId: 7,
consultorId: 434,
dataFim: "20/12/2025",
dataInicio: "16/12/2025",
formaPagamentoId: 184,
nomeEvento: "Evento Replicar Proposta",
quantidadePassageiros: 12,
solicitante: "Wanderson Borges",
solicitanteEmail: "wander.borges@abong.org.br",
solicitanteTelefone: "11918239848"
}
],
itens:[
{
comissao: 0,
dataFinal: "19/12/2025",
dataInicio: "16/12/2025",
destinoId: 0,
divisor: 0.62,
horaFinal: "",
horaInicio: "",
isComissiona: "N",
isCortesia: "N",
isPermuta: "N",
itinerarios: [
{
areaTarifario: "N",
bairro: "Papicu",
cep: "60175-055",
cidade: "Fortaleza",
complemento: "",
descricao: "",
estado: "Ceará",
latitude: -3.7418185000000004,
localParada: "Riomar",
logradouro: "Rua Desembargador Lauro Nogueira",
longitude: -38.4702255,
numero: "1500",
trecho: "P"
},
{
areaTarifario: "S",
bairro: "Edson Queiroz",
cep: "60811-341",
cidade: "Fortaleza",
complemento: "",
descricao: "Fortaleza",
estado: "Ceará",
latitude: null,
localParada: "Iguatemi - Avenida Washington Soares - Edson Queiroz, Fortaleza - CE",
logradouro: "Avenida Washington Soares",
longitude: null,
numero: "85",
trecho: "O"
},
{
areaTarifario: "S",
bairro: "Sapiranga-Coité",
cep: "60833-005",
cidade: "Fortaleza",
complemento: "",
descricao: "Fortaleza",
estado: "Ceará",
latitude: null,
localParada: "Via Sul Shopping - Avenida Washington Soares - Sapiranga-Coité, Fortaleza - CE",
logradouro: "Avenida Washington Soares",
longitude: null,
numero: "4335",
trecho: "D"
}
],
observacao: "Teste",
origemId: 0,
quantidadePassageiros: 1,
quantidadeVeiculos: 1,
servicoId: 60,
tarifarioId: null,
taxa: 5,
tipoDivisor: "C",
tipoMotoristaId: 2,
tipoServicoId: 6,
tipoTarifarioId: 1,
tipoVeiculoId: 10,
valorComTaxa: 0,
valorHoraVenda: 0,
valorKmVenda: 0,
valorTaxa: 0,
valorUnitario: 0,
valorVenda: 0
}
]
}
*/

/*
{
  "clientSelected": {
    "cnpj": "68630623000181",
    "comissao": 0,
    "divisor": 0.62,
    "divisorId": 129,
    "id": 137,
    "inscricaoEstadual": "",
    "inscricaoMunicipal": "",
    "nomeFantasia": "Abong",
    "pessoaId": 314,
    "pessoaJuridicaId": 275,
    "razaoSocial": "Associacao Brasileira de Organizacoes Nao Governamentais",
    "subCliente": "N",
    "taxa": 5,
    "tipoPessoa": null,
    "tipoPessoaId": 2
  },
  "subClientSelected": {
    "cnpj": "05936359069",
    "comissao": null,
    "descricaoTipoPessoa": "Pessoa Juridica",
    "divisor": null,
    "divisorId": null,
    "id": 150,
    "inscricaoEstadual": "",
    "inscricaoMunicipal": "",
    "nomeFantasia": "Teste ambi new",
    "pessoaId": 329,
    "pessoaJuridicaId": 290,
    "razaoSocial": "PF",
    "subCliente": "A",
    "taxa": null,
    "tipoPessoaId": 2
  },
  "consultantClientSelected": {
    "clienteId": 150,
    "consultorId": 466,
    "crc": "cl150-c466",
    "dataNascimento": null,
    "email": "ftfhfkyfuy@gmail.com",
    "id": 358,
    "nome": "ihhuhuhhuhu",
    "telefone": "25587287271",
    "telefone_transform": "(25) 58728-7271"
  },
  "ListItemsProposal": [
    {
      "cidadeDestino": "Fortaleza",
      "cidadeOrigem": "Fortaleza",
      "comissao": "0,00",
      "custo": "120,00",
      "custoFormatado": "R$ 120,00",
      "custoHoraExtra": "90,00",
      "custoHoraExtraFormatado": "R$ 4,00",
      "custoKmExtra": "4,00",
      "custoKmExtraFormatado": "R$ 90,00",
      "dataFinal": "17/12/2025",
      "dataFinalFormatada": "17/12/2025",
      "dataInicio": "16/12/2025",
      "dataInicioFormatada": "16/12/2025",
      "destination": {
        "bairro": "Sapiranga-Coité",
        "cep": "60833-005",
        "cidade": "Fortaleza",
        "complemento": "",
        "descricao": "Via Sul Shopping - Avenida Washington Soares - Sapiranga-Coité, Fortaleza - CE",
        "estado": "Ceará",
        "latitude": "",
        "logradouro": "Avenida Washington Soares",
        "longitude": "",
        "numero": "4335",
        "pais": "Brasil"
      },
      "destino": "Fortaleza",
      "destinoId": 9,
      "divisor": "0,65",
      "estadoDestino": "Ceará",
      "estadoOrigem": "Ceará",
      "horaFinal": "12:02",
      "horaInicio": "23:13",
      "idCreate": "F23",
      "intinerarios": [
        {
          "areaTarifario": "N",
          "bairro": "Edson Queiroz",
          "cep": "60811-341",
          "cidade": "Fortaleza",
          "complemento": "",
          "descricao": "Iguatemi",
          "estado": "Ceará",
          "idCreate": "F2F",
          "latitude": -3.7560474,
          "logradouro": "Avenida Washington Soares",
          "longitude": -38.4893449,
          "numero": "85",
          "pais": "Brasil",
          "trecho": "P"
        }
      ],
      "isComisionado": true,
      "isCortesia": false,
      "isPermuta": false,
      "numPessoas": 1,
      "numVeiculos": 1,
      "observacao": "Teste com tarifário",
      "origem": "Fortaleza",
      "origemId": 9,
      "origin": {
        "bairro": "Papicu",
        "cep": "60175-055",
        "cidade": "Fortaleza",
        "complemento": "",
        "descricao": "Shopping RioMar Fortaleza - Rua Desembargador Lauro Nogueira - Papicu, Fortaleza - CE",
        "estado": "Ceará",
        "latitude": "",
        "logradouro": "Rua Desembargador Lauro Nogueira",
        "longitude": "",
        "numero": "1500",
        "pais": "Brasil"
      },
      "perimetroUrbano": "S",
      "saleHoraExtra": "90,00",
      "saleHoraExtraFormatado": "R$ 90,00",
      "saleKmExtra": "4,00",
      "saleKmExtraFormatado": "R$ 4,00",
      "servico": "ida ou volta",
      "servicoId": 15,
      "tarifarioId": "06463c90-8849-4824-a21f-08de051a7f82",
      "taxa": "5,00",
      "tipoComissao": "T",
      "tipoMotorista": "Monolíngue",
      "tipoMotoristaId": 1,
      "tipoServico": "Transfer",
      "tipoServicoId": 6,
      "tipoTarifarioId": 1,
      "tipoVeiculo": "Sedan Executivo",
      "tipoVeiculoId": 16,
      "valorTaxa": "10,00",
      "valorTaxaFormatado": "R$ 10,00",
      "venda": "195,00",
      "vendaFormatado": "R$ 195,00",
      "vendaSemTaxa": "185,00",
      "vendaSemTaxaFormatado": "R$ 185,00",
      "vendaUnitario": "185,00",
      "vendaUnitarioFormatado": "R$ 185,00",
      "tarifario": {
        "ativo": "S",
        "cidadeDestino": "Fortaleza",
        "cidadeOrigem": "Fortaleza",
        "cliente": null,
        "clienteId": 0,
        "custo": 120,
        "custoHoraExtra": 90,
        "custoHoraExtra_formatado": "R$ 90,00",
        "custo_formatado": "R$ 120,00",
        "custokmExtra": 4,
        "custokmExtra_formatado": "R$ 4,00",
        "dataCriacao": "06/10/2025",
        "dataValidade": "02/02/2026",
        "destination": {
          "bairro": "Sapiranga-Coité",
          "cep": "60833-005",
          "cidade": "Fortaleza,",
          "complemento": "",
          "descricao": "Via Sul Shopping - Avenida Washington Soares - Sapiranga-Coité, Fortaleza - CE",
          "estado": "Ceará",
          "latitude": "",
          "logradouro": "Avenida Washington Soares",
          "longitude": "",
          "numero": "4335",
          "pais": "Brasil"
        },
        "destino": "Fortaleza",
        "destinoId": 9,
        "estadoDestino": "Ceará",
        "estadoOrigem": "Ceará",
        "fornecedor": "NATALVANS",
        "fornecedorId": 81,
        "horaCriacao": "18:01:33",
        "id": "06463c90-8849-4824-a21f-08de051a7f82",
        "import": null,
        "isComission": true,
        "location": "",
        "login": "diego.inacio@tgmob.com.br",
        "origem": "Fortaleza",
        "origemId": 9,
        "origin": {
          "bairro": "Papicu",
          "cep": "60175-055",
          "cidade": "Fortaleza",
          "complemento": "",
          "descricao": "Shopping RioMar Fortaleza - Rua Desembargador Lauro Nogueira - Papicu, Fortaleza - CE",
          "estado": "Ceará",
          "latitude": "",
          "logradouro": "Rua Desembargador Lauro Nogueira",
          "longitude": "",
          "numero": "1500",
          "pais": "Brasil"
        },
        "paisDestino": "Brasil",
        "paisOrigem": "Brasil",
        "perimetroUrbano": "S",
        "pessoaId": 129,
        "servico": "ida ou volta",
        "servicoId": 15,
        "standard": "N",
        "subCliente": null,
        "tipoId": 1,
        "tipoMotorista": "Monolíngue",
        "tipoMotoristaId": 1,
        "tipoServico": "Transfer",
        "tipoServicoId": 6,
        "tipoTarifario": "Standard",
        "tipoVeiculo": "Sedan Executivo",
        "tipoVeiculoId": 16,
        "usuario": "Diego Henrique da Silva Inácio",
        "usuarioId": 16
      }
    },
    {
      "cidadeDestino": "Fortaleza",
      "cidadeOrigem": "Fortaleza",
      "comissao": 0,
      "custo": "0,00",
      "custoFormatado": "R$ 0,00",
      "custoHoraExtra": "0,00",
      "custoHoraExtraFormatado": "R$ 0,00",
      "custoKmExtra": "0,00",
      "custoKmExtraFormatado": "R$ 0,00",
      "dataFinal": "17/12/2025",
      "dataFinalFormatada": "17/12/2025",
      "dataInicio": "16/12/2025",
      "dataInicioFormatada": "16/12/2025",
      "destination": {
        "bairro": "Sapiranga-Coité",
        "cep": "60833-005",
        "cidade": "Fortaleza",
        "complemento": "",
        "descricao": "Via Sul Shopping - Avenida Washington Soares - Sapiranga-Coité, Fortaleza - CE",
        "estado": "Ceará",
        "latitude": "",
        "logradouro": "Avenida Washington Soares",
        "longitude": "",
        "numero": "4335",
        "pais": "Brasil"
      },
      "destino": "Fortaleza - CE",
      "destinoId": 0,
      "divisor": 0.65,
      "estadoDestino": "Ceará",
      "estadoOrigem": "Ceará",
      "horaFinal": "12:02",
      "horaInicio": "23:13",
      "idCreate": "31E",
      "intinerarios": [
        {
          "areaTarifario": "S",
          "bairro": "Edson Queiroz",
          "cep": "60811-341",
          "cidade": "Fortaleza",
          "complemento": "",
          "descricao": "Iguatemi",
          "estado": "Ceará",
          "idCreate": "F2F",
          "latitude": -3.7560474,
          "logradouro": "Avenida Washington Soares",
          "longitude": -38.4893449,
          "numero": "85",
          "pais": "Brasil",
          "trecho": "P"
        }
      ],
      "isComisionado": true,
      "isCortesia": false,
      "isPermuta": false,
      "numPessoas": 1,
      "numVeiculos": 1,
      "observacao": "Teste sem tarifário",
      "origem": "Fortaleza - CE",
      "origemId": 0,
      "origin": {
        "bairro": "Papicu",
        "cep": "60175-055",
        "cidade": "Fortaleza",
        "complemento": "",
        "descricao": "Shopping RioMar Fortaleza - Rua Desembargador Lauro Nogueira - Papicu, Fortaleza - CE",
        "estado": "Ceará",
        "latitude": "",
        "logradouro": "Rua Desembargador Lauro Nogueira",
        "longitude": "",
        "numero": "1500",
        "pais": "Brasil"
      },
      "perimetroUrbano": "S",
      "saleHoraExtra": "0,00",
      "saleHoraExtraFormatado": "R$ 0,00",
      "saleKmExtra": "0,00",
      "saleKmExtraFormatado": "R$ 0,00",
      "servico": "ida ou volta",
      "servicoId": 15,
      "tarifario": {
        "destination": {
          "bairro": "Sapiranga-Coité",
          "cep": "60833-005",
          "cidade": "Fortaleza",
          "complemento": "",
          "descricao": "Via Sul Shopping - Avenida Washington Soares - Sapiranga-Coité, Fortaleza - CE",
          "estado": "Ceará",
          "latitude": "",
          "logradouro": "Avenida Washington Soares",
          "longitude": "",
          "numero": "4335",
          "pais": "Brasil"
        },
        "destino": "Fortaleza - CE",
        "destinoId": 0,
        "location": "",
        "origem": "Fortaleza - CE",
        "origemId": 0,
        "origin": {
          "bairro": "Papicu",
          "cep": "60175-055",
          "cidade": "Fortaleza",
          "complemento": "",
          "descricao": "Shopping RioMar Fortaleza - Rua Desembargador Lauro Nogueira - Papicu, Fortaleza - CE",
          "estado": "Ceará",
          "latitude": "",
          "logradouro": "Rua Desembargador Lauro Nogueira",
          "longitude": "",
          "numero": "1500",
          "pais": "Brasil"
        },
        "perimetroUrbano": "S",
        "servico": "ida ou volta",
        "servicoId": 15,
        "tipoMotorista": "Monolíngue",
        "tipoMotoristaId": 1,
        "tipoServico": "Transfer",
        "tipoServicoId": 6,
        "tipoTarifarioId": 1,
        "tipoVeiculo": "Ônibus Executivo Semi-leito",
        "tipoVeiculoId": 14
      },
      "taxa": 5,
      "tipoComissao": "T",
      "tipoMotorista": "Monolíngue",
      "tipoMotoristaId": 1,
      "tipoServico": "Transfer",
      "tipoServicoId": 6,
      "tipoTarifarioId": 1,
      "tipoVeiculo": "Ônibus Executivo Semi-leito",
      "tipoVeiculoId": 14,
      "valorTaxa": "0,00",
      "valorTaxaFormatado": "R$ 0,00",
      "venda": "0,00",
      "vendaFormatado": "R$ 0,00",
      "vendaSemTaxa": "0,00",
      "vendaSemTaxaFormatado": "R$ 0,00",
      "vendaUnitario": "0,00",
      "vendaUnitarioFormatado": "R$ 0,00"
    }
  ],
  "ListServiceAdditional": [
    {
      "date_formatted": "16/12/2025",
      "descricao": "Água 500 ml sem gás",
      "idCreate": "961",
      "priceTotal": "21,00",
      "priceTotal_formatted": "R$ 21,00",
      "priceUnit": "10,00",
      "priceUnit_formatted": "R$ 10,00",
      "serviceAdditional": {
        "atualizadoPor": null,
        "criadoPor": 9,
        "dataAtualizacao": "01/01/1900",
        "dataCriacao": "29/09/2025",
        "descricao": "Água 500 ml sem gás",
        "horaAtualizacao": "00:00:00",
        "horaCriacao": "19:39:18",
        "id": 12,
        "valor": 10,
        "valorFormatado": "10,00"
      },
      "serviceAdditionalId": 12,
      "tax": 5,
      "tax_formatted": "5,00 %"
    }
  ]
}
*/
